module.exports = __webpack_public_path__ + "TheWindsNocturne.webp?b69643a248b54c0311166a4957db4588";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/TheWindsNocturne.webp
// module id = 166
// module chunks = 0